import { axiosBase } from '../../api/axios-base';

const state = {
  markers: [],
  filteredMarkers: [],
  focusCoord: {zoom: 10, center: [55.78874, 49.12214]},
  selectedMarker: []
};
const getters = {
  MARKERS: (state) => {
    return state.filteredMarkers.length == 0
      ? state.markers
      : state.filteredMarkers;
  },
  MARKERS_COUNTER: (state) => {
    return state.markers.length
  },
  FOCUS_COORD: (state) => {
    return state.focusCoord
  },
  SELECTED_MARKER: (state) => {
    return state.selectedMarker
  }
};
const mutations = {
  SET_MARKERS: (state, payload) => {
    state.markers = payload;
  },
  SET_FILTERED_MARKERS: (state, payload) => {
    state.filteredMarkers = payload;
  },
  SET_FOCUS_COORD: (state, payload) => {
    state.focusCoord = payload;
  },
  SET_SELECTED_MARKER: (state, payload) => {
    state.selectedMarker = payload;
  },
};
const actions = {
  GET_SELECTED_MARKER: async (context, id) => {
    let { data } = await axiosBase.get("/api/v1/dtpdetail/" + id);
    context.commit("SET_SELECTED_MARKER", data);
  },
  GET_MARKERS: async (context, parameters) => {
    let { data } = await axiosBase.get("/api/v1/filter/dtp", {
      params: {
        location: parameters.location.length === 1 ? parameters.location.join("") : parameters.location.join("|"),
        type_dtp: parameters.type_dtp.length === 1 ? parameters.type_dtp.join("") : parameters.type_dtp.join("|"),
        lighting: parameters.lighting.length === 1 ? parameters.lighting.join("") : parameters.lighting.join("|"),
        weather_1: parameters.weather_1.length === 1 ? parameters.weather_1.join("") : parameters.weather_1.join("|"),
        road_condition: parameters.road_condition.length === 1 ? parameters.road_condition.join("") : parameters.road_condition.join("|"),
        coating_type: parameters.coating_type.length === 1 ? parameters.coating_type.join("") : parameters.coating_type.join("|"),
        year: parameters.year,
        dividing_line_type: parameters.dividing_line_type.length === 1 ? parameters.dividing_line_type.join("") : parameters.dividing_line_type.join("|"),
        ndu_1: parameters.ndu_1.length === 1 ? parameters.ndu_1.join("") : parameters.ndu_1.join("|"),
        uds_inplace_1: parameters.uds_inplace_1.length === 1 ? parameters.uds_inplace_1.join("") : parameters.uds_inplace_1.join("|"),
        uds_near_1: parameters.uds_near_1.length === 1 ? parameters.uds_near_1.join("") : parameters.uds_near_1.join("|"),
        time_after: parameters.time_after,
        time_before: parameters.time_before,
        date_after: parameters.date_after,
        date_before: parameters.date_before,
        loss: parameters.loss,
        loss_child: parameters.loss_child,
        injured: parameters.injured,
        injured_child: parameters.injured_child
      }
    });
    context.commit("SET_MARKERS", data);
  },
  GET_FOCUS_COORD: ({commit}, focus) => {
    commit("SET_FOCUS_COORD",focus);
  }
};

export default {
  state,
  getters,
  mutations,
  actions,
};

